"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var isObjectLike_1 = __importDefault(require("lodash/isObjectLike"));

var adapter_1 = require("../helpers/adapter");

var constants_1 = require("../constants");

var filters_1 = require("../filters");

var DataService =
/*#__PURE__*/
function () {
  function DataService(datasetId, widgetId, adapter, setEditor, dispatch) {
    _classCallCheck(this, DataService);

    this.adapter = adapter;
    adapter_1.setAdapter(this.adapter);
    this.setEditor = setEditor;
    this.dispatch = dispatch;
    this.dataset = null;
    this.widgetId = widgetId;
    this.widget = null;
    this.widgetData = null;
    this.adapter.setDatasetId(datasetId);
  }

  _createClass(DataService, [{
    key: "getDatasetAndWidgets",
    value: function getDatasetAndWidgets() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.adapter.getDataset();

              case 2:
                this.dataset = _context.sent;
                _context.next = 5;
                return this.adapter.getWidget(this.dataset, this.widgetId);

              case 5:
                this.widget = _context.sent;
                this.setEditor({
                  dataset: this.dataset,
                  widget: this.widget
                });
                this.dispatch({
                  type: constants_1.sagaEvents.DATA_FLOW_DATASET_WIDGET_READY
                });

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "restoreEditor",
    value: function restoreEditor(datasetId, widgetId) {
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var _a, _b, _c, _d, _e, _f;

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.setEditor({
                  restoring: true
                });
                this.dispatch({
                  type: constants_1.sagaEvents.DATA_FLOW_RESTORE
                });
                this.widgetId = widgetId;
                this.adapter.setDatasetId(datasetId);
                _context2.next = 6;
                return this.getDatasetAndWidgets();

              case 6:
                _context2.next = 8;
                return this.getFieldsAndLayers();

              case 8:
                _context2.next = 10;
                return this.handleFilters();

              case 10:
                this.handleEndUserFilters();
                this.setEditor({
                  widgetData: [],
                  advanced: !((_b = (_a = this.widget) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b.widgetConfig) ? false : !this.widget.attributes.widgetConfig.paramsConfig
                });

                if ((_d = (_c = this.widget) === null || _c === void 0 ? void 0 : _c.attributes) === null || _d === void 0 ? void 0 : _d.widgetConfig) {
                  this.dispatch({
                    type: constants_1.reduxActions.EDITOR_SET_WIDGETCONFIG,
                    payload: (_f = (_e = this.widget) === null || _e === void 0 ? void 0 : _e.attributes) === null || _f === void 0 ? void 0 : _f.widgetConfig
                  });
                }

                if (cb) {
                  cb();
                }

                this.setEditor({
                  restoring: false
                });
                this.dispatch({
                  type: constants_1.sagaEvents.DATA_FLOW_VISUALIZATION_READY
                });
                this.dispatch({
                  type: constants_1.sagaEvents.DATA_FLOW_RESTORED
                });

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "handleFilters",
    value: function handleFilters() {
      var restore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var _a, _b;

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3() {
        var paramsConfig, filters, orderBy, color, deserializedFilters;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (this.widget) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return", null);

              case 2:
                paramsConfig = (_b = (_a = this.widget.attributes) === null || _a === void 0 ? void 0 : _a.widgetConfig) === null || _b === void 0 ? void 0 : _b.paramsConfig;
                filters = paramsConfig === null || paramsConfig === void 0 ? void 0 : paramsConfig.filters;
                orderBy = null;
                color = null;

                if (!(filters && Array.isArray(filters) && filters.length > 0)) {
                  _context3.next = 17;
                  break;
                }

                if (isObjectLike_1["default"](paramsConfig.orderBy)) {
                  orderBy = paramsConfig.orderBy;
                }

                if (isObjectLike_1["default"](paramsConfig.color)) {
                  color = paramsConfig.color;
                }

                _context3.next = 11;
                return filters_1.getDeserializedFilters(filters, this.allowedFields, this.dataset);

              case 11:
                deserializedFilters = _context3.sent;

                if (!restore) {
                  _context3.next = 16;
                  break;
                }

                return _context3.abrupt("return", deserializedFilters);

              case 16:
                this.dispatch({
                  type: constants_1.reduxActions.EDITOR_SET_FILTERS,
                  payload: {
                    color: color,
                    orderBy: orderBy,
                    list: deserializedFilters
                  }
                });

              case 17:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "handleEndUserFilters",
    value: function handleEndUserFilters() {
      var _a, _b, _c;

      if (!this.widget) {
        return;
      }

      var endUserFilters = (_c = (_b = (_a = this.widget.attributes) === null || _a === void 0 ? void 0 : _a.widgetConfig) === null || _b === void 0 ? void 0 : _b.paramsConfig) === null || _c === void 0 ? void 0 : _c.endUserFilters;

      if (endUserFilters) {
        this.dispatch({
          type: constants_1.reduxActions.EDITOR_SET_END_USER_FILTERS,
          payload: endUserFilters
        });
      }
    }
  }, {
    key: "isFieldAllowed",
    value: function isFieldAllowed(field) {
      var fieldTypeAllowed = constants_1.ALLOWED_FIELD_TYPES.find(function (val) {
        return val.name.toLowerCase() === field.type.toLowerCase();
      });
      var isCartodbId = field.columnName === "cartodb_id";
      var result = !isCartodbId && fieldTypeAllowed;
      return result;
    }
  }, {
    key: "getFieldsAndLayers",
    value: function getFieldsAndLayers() {
      var _a, _b, _c, _d;

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee4() {
        var _this = this;

        var fields, layers, columns;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.adapter.getFields();

              case 2:
                fields = _context4.sent;
                _context4.next = 5;
                return this.adapter.getLayers();

              case 5:
                layers = _context4.sent;
                columns = (_d = (_c = (_b = (_a = this.dataset) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b.metadata[0]) === null || _c === void 0 ? void 0 : _c.attributes) === null || _d === void 0 ? void 0 : _d.columns;
                this.allowedFields = [];

                if (fields && Object.keys(fields).length > 0) {
                  Object.keys(fields).forEach(function (field) {
                    var _a;

                    var f = Object.assign(Object.assign({}, fields[field]), {
                      columnName: field,
                      metadata: (_a = columns === null || columns === void 0 ? void 0 : columns[field]) !== null && _a !== void 0 ? _a : {}
                    });

                    if (_this.isFieldAllowed(f)) {
                      _this.allowedFields.push(f);
                    }
                  });
                }

                this.dispatch({
                  type: constants_1.sagaEvents.DATA_FLOW_FIELDS_AND_LAYERS_READY
                });
                this.setEditor({
                  layers: layers,
                  fields: this.allowedFields
                });

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "requestWithFilters",
    value: function requestWithFilters(store) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee5() {
        var request;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.adapter.requestData(store);

              case 2:
                request = _context5.sent;

                if (!request.data || "errors" in request) {
                  this.setEditor({
                    errors: ["WIDGET_DATA_UNAVAILABLE"]
                  });
                } else {
                  this.setEditor({
                    widgetData: request.data
                  });
                }

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "resolveInitialState",
    value: function resolveInitialState() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.getDatasetAndWidgets();

              case 2:
                _context6.next = 4;
                return this.getFieldsAndLayers();

              case 4:
                _context6.next = 6;
                return this.handleFilters();

              case 6:
                this.handleEndUserFilters();
                this.dispatch({
                  type: constants_1.sagaEvents.DATA_FLOW_VISUALIZATION_READY
                });
                this.dispatch({
                  type: constants_1.sagaEvents.DATA_FLOW_RESTORED
                });

              case 9:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
  }]);

  return DataService;
}();

exports["default"] = DataService;